enum Actions {
    ADD = "add",
    REMOVE = "remove"
}

export default Actions